module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_06B.45e5b2a7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_06B.mp3
// module id = 108
// module chunks = 0